import Mousetrap from "mousetrap";
/*
@Warning: this code needs to be refactored
*/
const Notif = require("izitoast");

const UI = (function() {
  function UI() {
    this.init();
  }
  UI.modals = [];

  UI.prototype.init = function() {
    Notif.settings({
      id: null,
      class: "",
      title: "",
      theme: "dark",
      position: "topCenter", // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
      timeout: 5000,
      animateInside: true,
      drag: true,
      pauseOnHover: true,
      resetOnHover: false,
      progressBar: false,
      progressBarColor: "rgb(0, 255, 184)"
    });
    UI._DOM_prototypes = {
      topNotification: {
        element: $('<div class="ixcanul-ui ixcanul-notifcations top-notification"/>')
      }
    };
    return UI.constructor;
  };
  /**
   * @function replaceNotif
   * @return {type} {description}
   */
  function replaceNotif({ id, message = "", _type, title = "", timeout = 2000, reset_timeout = false }) {
    removeExtraInstances(id);
    const toast = document.querySelector(id);
    if (toast) {
      const toastBody = toast.querySelector(".iziToast-body");
      const toastIcon = toast.querySelector(".iziToast-body > i");
      const toastTile = toast.querySelector(".iziToast-body .iziToast-title");
      if (toast.classList.contains("iziToast-color-red")) {
        toast.classList.replace("iziToast-color-red", "iziToast-color-green");
      }
      toastIcon
        ? toastIcon.classList.replace("ico-error", "ico-success")
        : $(toastBody).prepend('<i class="ico-success"></i>');
      toastTile && (toastTile.innerText = title);
      console.log(message);
      toast.querySelector(".iziToast-body .iziToast-message").innerHTML = message;
      if (!reset_timeout) {
        setTimeout(() => {
          toast.querySelector("button").click();
        }, timeout);
      }
    }
    return undefined;
  }

  /**
   * This function adds some flexibility to the iziTast data structure
   * @function extendData
   * @param  {type} settings {description}
   * @return {Object} the new settings object
   */
  function extendData(settings) {
    const formattedSettings = settings;
    const { id } = settings;
    const currentMessage = document.querySelector(`#${id} .iziToast-message`);

    if (typeof formattedSettings.message === "function") {
      const messageHTML = currentMessage ? currentMessage.innerHTML : "";
      formattedSettings["message"] = formattedSettings.message(messageHTML);
      console.log(formattedSettings["message"]);
    }
    return formattedSettings;
  }

  UI.notif = function(data) {
    if (data) {
      const options = extendData(data);
      const { id, replace, reset_timeout } = options;
      if (replace === true && id) {
        const toast = document.querySelector(`#${id}`);
        if (reset_timeout && toast) {
          const ref = Object.keys(Notif).find(i => Notif[i].id === id);
          const settings = Notif[ref];
          Notif.progress(settings, toast, function() {
            Notif.progress(settings, toast).resume();
          }).reset();
        }
        replaceNotif(Object.assign({}, options, { id: "#" + id, type: "show" }));
      } else {
        Notif.show(data);
      }
    }
    UI.notif.error = data => {
      Notif.error(data);
    };
    UI.notif.success = data => {
      if (data.replace === true && data.id) {
        replaceNotif(Object.assign({}, data, { id: "#" + data.id, type: "success" }));
      } else {
        Notif.success(data);
      }
    };
    UI.notif.warning = data => {
      Notif.warning(data);
    };
    UI.notif.info = data => {
      Notif.info(data);
    };
    UI.notif.destroy = data => {
      Notif.destroy(data);
    };
    return UI.notif;
  };

  UI.topNotification = function(content) {
    this.notification = {};
    this.notification.element = new UI.prototype._instanceDOM("topNotification");
    this.notification.tempClasses = "ixc-ui-success ixc-ui-error ixc-ui-warning";
    this.notification.element.removeClass(this.notification.tempClasses);
    if (content) {
      this.notification.element.html(content);
    }
    $(".page-container").append(this.notification.element);

    this.notification.destroy = function(timer) {
      timer = timer || 0;
      let that = this;
      setTimeout(function() {
        that.element.remove();
      }, timer);
    };
    this.notification.setContent = function(msg) {
      this.element.html(msg);
    };
    this.notification.success = function(msg) {
      this.element.addClass("ixc-ui-success");
      this.element.html(msg);
    };
    this.notification.warning = function(msg) {
      this.element.addClass("ixc-ui-warning");
      this.element.html(msg);
    };
    this.notification.error = function(msg) {
      this.element.addClass("ixc-ui-error");
      this.element.html(msg);
    };
    return this.notification;
  };

  UI.modal = (classes, id) => {
    let $tingle = require("tingle.js");
    let modal = new $tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      closeLabel: "Close",
      cssClass: (classes + " mw_ixcanul").split(" "),
      id: id || "modal-" + CodeEditor.GUID(),
      close: () => {
        console.log("closing");
        if (tree.getActiveNode !== null) {
          tree.setFocus();
        }
        CodeEditor.UI.modals = CodeEditor.UI.modals.filter(i => i.opts.id !== modal.opts.id);
        if (modal.opts.closecallback) {
          modal.opts.closecallback();
        }
        modal.destroy();
      },
      onOpen: () => {
        $(".tingle-modal--visible")[0].focus();
        let $forms = $(".tingle-modal--visible").find("form");
        let $primarybtn = $(".tingle-modal--visible").find(".tingle-btn--primary");
        if ($forms.length === 0) {
          if ($primarybtn.length > 0) {
            $primarybtn.trigger("focus");
          }
        }
        console.log("modal open");
        console.log(modal);

        Mousetrap(document.body).bind(["esc", "escape"], function() {
          modal.opts.close();
          return false;
        });
        // Mousetrap(document.body).bind('enter', function(e) {
        //   return false;
        // });
        $(".tingle-modal--visible").off("click.ixcanulModal");
        $(".tingle-modal--visible").on("click.ixcanulModal", function(e) {
          if (e.target.classList && e.target.classList.contains("tingle-modal--visible")) {
            modal.opts.close();
          }
        });
      },
      onClose: () => {
        // doesn't work!, dependency issue.
        console.log("modal closed");
        if (tree.getActiveNode !== null) {
          tree.setFocus();
        }
        CodeEditor.UI.modals = CodeEditor.UI.modals.filter(i => i.opts.id !== modal.opts.id);
        modal.destroy();
      },
      beforeOpen: () => {
        console.log("beforeOpen");
      },
      beforeClose: () => {
        console.log("beforeClose");
      }
    });
    UI.modals.push(modal);
    return modal;
  };
  UI.prototype._instanceDOM = function(UI_prototypeName, id, classArray) {
    this.DOMElement = UI._DOM_prototypes[String(UI_prototypeName)].element;
    if (id) {
      this.DOMElement.attr("id", String(id));
    }
    if (classArray) {
      this.DOMElement.addClass(String(...[classArray]).replace(",", " "));
    }
    UI.prototype._instanceDOM.constructor = () => this.DOMElement;
    return this.DOMElement;
  };

  return UI;
})();
// window.UI = CodeEditor.UI;
export default UI;

/**
 * Decorates any asynchronous function with a success/error notification
 *
 * @param {function} fn the function to decorate
 * @param {string} successMsg message to show if the operation is successful
 * @return {Promise} the result of the function
 */
export function asyncNotiDecorator(fn, successMsg) {
  return function() {
    return new Promise((resolve, reject) => {
      fn.apply(null, arguments)
        .then(result => {
          new UI.notif().success({message: successMsg});
          resolve(result);
        })
        .catch(error => {
          new UI.notif().error({message: error});
          reject(error);
        })
    });
  }
}

function removeExtraInstances(selector) {
  const multipleInstances = [].slice.call(document.querySelectorAll(selector));
  if (multipleInstances.length > 1) {
    multipleInstances.slice(1).forEach(element => {
      $(element.parentElement).remove();
    });
  }
}
window.Notif = Notif;
